import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "visitor-profile" }
const _hoisted_2 = { class: "blacklist-image" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Hide ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(_toDisplayString(_ctx.blacklistInfo.remarks) + " ", 1),
    _createVNode(_component_el_popover, {
      ref: "showBlacklistInfo",
      "popper-class": "visitor-blacklist-popup",
      placement: "right",
      width: 300,
      disabled: !_ctx.blacklisted
    }, {
      reference: _withCtx(() => [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  prop: "salutation",
                  label: _ctx.trans('label.salutation'),
                  rules: {
								required: true,
								message: _ctx.trans(
									'message.field_require',
									_ctx.trans('label.salutation')
								)
							}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.model.salutation,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.salutation) = $event)),
                      "automatic-dropdown": false,
                      onChange: _ctx.checkBlacklist
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: _ctx.trans('label.mr'),
                          value: "Mr"
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_option, {
                          label: _ctx.trans('label.ms'),
                          value: "Ms"
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_option, {
                          label: _ctx.trans('label.mrs'),
                          value: "Mrs"
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_option, {
                          label: _ctx.trans('label.miss'),
                          value: "Miss"
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_option, {
                          label: _ctx.trans('label.prof'),
                          value: "Prof"
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_option, {
                          label: _ctx.trans('label.dr'),
                          value: "Dr"
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 9 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  prop: "lastName",
                  label: _ctx.trans('label.last-name'),
                  rules: {
								required: true,
								message: _ctx.trans(
									'message.field_require',
									_ctx.trans('label.last-name')
								)
							}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      ref: "name",
                      modelValue: _ctx.model.lastName,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.lastName) = $event)),
                      maxlength: "50",
                      "show-word-limit": "",
                      onChange: _ctx.checkBlacklist
                    }, null, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 9 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  prop: "firstName",
                  label: _ctx.trans('label.first-name')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.model.firstName,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.firstName) = $event)),
                      maxlength: "50",
                      "show-word-limit": "",
                      onChange: _ctx.checkBlacklist
                    }, null, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }),
            (_ctx.blacklisted)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "el-form-item__error blacklisted-error",
                  onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.showBlacklistInfo = true), ["prevent"]))
                }, " This visitor is blacklisted "))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_form, {
            "label-position": "top",
            "label-width": "120px"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("img", {
                  src: _ctx.blacklistInfo.image
                }, null, 8, _hoisted_3)
              ]),
              _createVNode(_component_el_form_item, {
                label: _ctx.trans('label.remarks')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.blacklistInfo.remarks,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.blacklistInfo.remarks) = $event)),
                    type: "textarea",
                    autosize: {
								minRows: 5,
								maxRows: 15
							}
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _ctx.trans('label.blacklisted-by')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.blacklistInfo.blacklistedBy,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.blacklistInfo.blacklistedBy) = $event)),
                    readonly: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    class: "hide-blacklist",
                    type: "warning",
                    size: "small",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.showBlacklistInfo = false), ["prevent"]))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "contactNo",
              label: _ctx.trans('label.visitor-phone-no'),
              rules: {
						required: true
					}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.model.contactNo,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.model.contactNo) = $event)),
                  maxlength: "20",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "visitorCompany",
              label: _ctx.trans('label.visitor-company')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.model.visitorCompany,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.model.visitorCompany) = $event)),
                  maxlength: "100",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "visitDate",
              label: _ctx.trans('label.visit-date'),
              rules: {
						required: true,
						message: _ctx.trans('message.field_require', _ctx.trans('label.visit-date'))
					}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.visitDate,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.visitDate) = $event)),
                  type: "date",
                  placeholder: _ctx.trans('label.nothing-selected'),
                  format: "DD-MM-YYYY",
                  clearable: false
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label", "rules"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "visitDate",
              label: _ctx.trans('label.visit-time'),
              rules: {
						required: true,
						message: _ctx.trans('message.field_require', _ctx.trans('label.visit-time'))
					}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_time_picker, {
                  modelValue: _ctx.visitTime,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.visitTime) = $event)),
                  format: "HH:mm",
                  placeholder: _ctx.trans('label.nothing-selected')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label", "rules"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "otherName",
              label: _ctx.trans('label.event-name')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.model.otherName,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.model.otherName) = $event)),
                  maxlength: "200",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "visitorType",
              label: _ctx.trans('label.visitor-type'),
              rules: {
						required: true,
						message: _ctx.trans('message.field_require', _ctx.trans('label.visitor-type'))
					}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.model.visitorType,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.model.visitorType) = $event)),
                  placeholder: _ctx.trans('label.nothing-selected'),
                  "automatic-dropdown": false
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (type) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: type.recordTypeName,
                        value: type.recordTypeId
                      }, null, 8, ["label", "value"]))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label", "rules"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_form_item, {
      prop: "remarks",
      label: _ctx.trans('label.remarks')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: _ctx.model.remarks,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.model.remarks) = $event)),
          type: "textarea",
          maxlength: 200,
          rows: 2,
          "show-word-limit": ""
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["label"]),
    _createVNode(_component_el_form_item, {
      prop: "entryType",
      label: _ctx.trans('label.entry-type')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_radio_group, {
          modelValue: _ctx.model.entryType,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.model.entryType) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio, { label: "Single-entry" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.trans("label.single-entry")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio, { label: "1-Day" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.trans("label.1day")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["label"])
  ]))
}